<template>
    <div>
        <div v-for="comDiff in diff.diffs">
            <v-text-field
              readonly
              v-model="comDiff.new"
              outlined
              hide-details
              :class="getInputClass(comDiff)"
            >
            </v-text-field>
            <div class="d-flex mt-2" v-if="comDiff.old !== null">
                        <span class="mr-2" :style="'color:' + updateColors.deep"
                              v-if="comDiff.new !== null">
                            Avant:
                        </span>
                <span class="mr-2" :style="'color:' + deleteColors.deep" v-else>Supprimé:</span>
                <span class="px-2 rounded" v-if="comDiff.new !== null"
                      :style="'background-color:' + updateColors.deep + '; color:' + updateColors.light">
                            {{ comDiff.old }}
                        </span>
                <span class="px-2 rounded" v-else
                      :style="'background-color:' + deleteColors.deep + '; color:' + deleteColors.light">
                            {{ comDiff.old }}
                        </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "comDiffs",
    props: ["diff"],
    methods: {
        getInputClass(diff) {
            if (diff.new !== null && diff.old === null) {
                return "input-add"
            } else if (diff.new !== null && diff.old !== null) {
                return "input-update"
            } else if (diff.new === null && diff.old !== null) {
                return "input-error"
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>